import React from 'react';
import { BrowserRouter, Routes, Route, useParams } from 'react-router-dom';

import { ContentProvider, useYear } from './lib/content.jsx';
import { Layout } from './components/Layout.jsx';
import { Loading, ErrorNotice, Empty } from './components/states.jsx';

import Home from './pages/Home.jsx';
import Lectures from './pages/Lectures.jsx';
import Assignments from './pages/Assignments.jsx';
import Grading from './pages/Grading.jsx';
import Materials from './pages/Materials.jsx';
import Archive from './pages/Archive.jsx';
import NotFound from './pages/NotFound.jsx';
import Admin from './pages/admin/Admin.jsx';

import './styles/tokens.css';
import './styles/base.css';
import './styles/app.css';

/**
 * Stránky jednoho ročníku. Bez slugu v URL jde o aktuální ročník na kořeni webu,
 * se slugem o archiv pod /archiv/<rok>. Obě varianty sdílí stejné komponenty.
 */
function YearSite() {
  const { yearSlug } = useParams();
  const { year, archived, status, error } = useYear(yearSlug);
  const basePath = yearSlug ? `/archiv/${yearSlug}` : '';

  if (status === 'loading') {
    return <Layout basePath={basePath}><Loading /></Layout>;
  }
  if (status === 'error') {
    return (
      <Layout basePath={basePath}>
        <ErrorNotice>
          {error} Zkuste stránku načíst znovu — pokud potíže trvají, neběží server s obsahem.
        </ErrorNotice>
      </Layout>
    );
  }
  if (!year) {
    return (
      <Layout basePath="">
        <Empty title="Ročník nenalezen">Takový školní rok tu není. Zkuste archiv.</Empty>
      </Layout>
    );
  }

  return (
    <Layout year={year} archived={archived} basePath={basePath}>
      <Routes>
        <Route index element={<Home />} />
        <Route path="hodiny" element={<Lectures />} />
        <Route path="ukoly" element={<Assignments />} />
        <Route path="znamkovani" element={<Grading />} />
        <Route path="materialy" element={<Materials />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <ContentProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/admin/*" element={<Admin />} />
          <Route path="/archiv" element={<Archive />} />
          <Route path="/archiv/:yearSlug/*" element={<YearSite />} />
          <Route path="/*" element={<YearSite />} />
        </Routes>
      </BrowserRouter>
    </ContentProvider>
  );
}
